import { API_BASE } from "../utils/baseapiurl";

class ReportsAPI {
	async getReports(period = null) {
		try {
			const url = new URL(`${API_BASE}/reports`, window.location.origin);
			if (period) url.searchParams.set("period", period);

			const response = await fetch(url.toString(), {
				method: "GET",
				headers: {
					"Content-Type": "application/json",
					"X-WP-Nonce": window.wpApiSettings?.nonce || "",
				},
				credentials: "include",
			});

			if (!response.ok) {
				throw new Error("Failed to fetch reports summary");
			}

			return await response.json();
		} catch (error) {
			console.error("Error fetching reports:", error);
			throw error;
		}
	}
}

export default new ReportsAPI();
